import { useUnreadSummary } from "@apps/community_chat/frontend/hooks";
import { useAIFeatureEnabled } from "@shared/hooks/use-paywall";

export function ChatNavBadge() {
  const { enabled } = useAIFeatureEnabled("community_chat");
  const { data } = useUnreadSummary({ isSocketConnected: false });

  const count = data?.totalUnread ?? 0;

  if (!enabled || count === 0) return null;

  const display = count >= 100 ? "99+" : String(count);

  return (
    <span
      className="ms-1 inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-destructive px-1.5 text-xs text-destructive-foreground"
      aria-label={`${count} unread messages`}
    >
      {display}
    </span>
  );
}

export default ChatNavBadge;
